<tour-step-template></tour-step-template>
<router-outlet></router-outlet>